import React from "react";
import FeatherIcon from "feather-icons-react";
import { useAuthStore } from "../stores/useAuthStore";

const NavdataAlerte = () => {
  const user = useAuthStore((s) => s.user);
  const isAdministrateur =
    Boolean(user?.roles && Array.isArray(user.roles) && user.roles.includes("ROLE_ADMINISTRATEUR"));

  const menuItems: any = [
    { label: "Road Alert", isHeader: true },
    {
      id: "dashboard",
      label: "Tableau de bord",
      icon: <FeatherIcon icon="layout" className="icon-dual" />,
      link: "/dashboard-alertes",
    },
    {
      id: "grandPublic",
      label: "Grand public",
      icon: <FeatherIcon icon="users" className="icon-dual" />,
      link: "/alertes-grand-public",
    },
    {
      id: "nonAffectees",
      label: "Non Affectées",
      icon: <FeatherIcon icon="user-x" className="icon-dual" />,
      link: "/alertes-non-affectees",
    },
    {
      id: "nonDemarrees",
      label: "Non Démarrées",
      icon: <FeatherIcon icon="power" className="icon-dual" />,
      link: "/alertes-non-demarrees",
    },
    {
      id: "enPause",
      label: "En pause",
      icon: <FeatherIcon icon="pause-circle" className="icon-dual" />,
      link: "/alertes-en-pause",
    },
    {
      id: "enCours",
      label: "En cours",
      icon: <FeatherIcon icon="settings" className="icon-dual" />,
      link: "/alertes-en-cours",
    },
    {
      id: "terminees",
      label: "Terminées",
      icon: <FeatherIcon icon="check-circle" className="icon-dual" />,
      link: "/alertes-terminees",
    },
    {
      id: "arretees",
      label: "Arrêtées",
      icon: <FeatherIcon icon="slack" className="icon-dual" />,
      link: "/alertes-arretees",
    },
    ...(isAdministrateur
      ? [
          {
            id: "parametres",
            label: "Paramètres",
            icon: <FeatherIcon icon="settings" className="icon-dual" />,
            link: "/parametres",
          },
        ]
      : []),
    {
      id: "etats",
      label: "Etats",
      icon: <FeatherIcon icon="file-text" className="icon-dual" />,
      link: "/etats",
    },
    {
      id: "exportationData",
      label: "Exportation Data",
      icon: <FeatherIcon icon="download" className="icon-dual" />,
      link: "/exportation-data",
    },
    {
      id: "cartographie",
      label: "Cartographie",
      icon: <FeatherIcon icon="map" className="icon-dual" />,
      link: "/cartographie",
    },
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default NavdataAlerte;
